import { Button, LabeledContainer } from '@schibsted-svp/react-ui';
import { useLiveArchiveExpirationQuery, useLiveArchiveQuery } from 'services/admin-bff-sdk';
import { useCallback, useEffect, useState } from 'react';
import css from './ClipCreate.module.scss';

type ClipCreateProps = {
    assetId: number;
    provider: string;
    disabled: boolean;
    onClick: React.ComponentProps<typeof Button>['onClick'];
    loading: boolean;
};

const POLLING_INTERVAL = 20000;

export function ClipCreate({ assetId, provider, disabled, onClick, loading }: ClipCreateProps) {
    const [pollingInterval, setPollingInterval] = useState(POLLING_INTERVAL);

    const { data: liveArchiveData } = useLiveArchiveQuery({ newsroom: provider, assetId });

    const { data: liveArchiveExpirationData } = useLiveArchiveExpirationQuery(
        { assetId, provider },
        { pollingInterval, skip: !liveArchiveData?.liveArchive }
    );

    const createClip = useCallback(() => {
        const liveArchiveExpiration = liveArchiveExpirationData?.liveArchiveExpiration;

        return onClick(
            !!liveArchiveData?.liveArchive,
            liveArchiveExpiration ? liveArchiveExpiration * 1000 : undefined
        );
    }, [liveArchiveData?.liveArchive, liveArchiveExpirationData?.liveArchiveExpiration, onClick]);

    useEffect(() => {
        if (liveArchiveExpirationData?.liveArchiveExpiration) {
            setPollingInterval(0);
        }
    }, [liveArchiveExpirationData?.liveArchiveExpiration]);

    return (
        <div className={css.clipCreate}>
            <LabeledContainer>
                <Button type="button" size="small" disabled={disabled} onClick={createClip} loading={loading}>
                    Create clip
                </Button>
            </LabeledContainer>
        </div>
    );
}
